import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy, Download, ExternalLink } from "lucide-react";
import { API } from "@/lib/api";
import { toast } from "sonner";

export default function QrModal({ card, open, onOpenChange }) {
  if (!card) return null;
  const publicUrl = card.public_url;
  const qrUrl = `${API}/public/cards/${card.id}/qr.png`;

  const copy = async () => {
    await navigator.clipboard.writeText(publicUrl);
    toast.success("URL copiato negli appunti");
  };
  const download = async () => {
    const res = await fetch(qrUrl);
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `qr_${card.id}.png`;
    a.click();
    URL.revokeObjectURL(a.href);
    toast.success("QR scaricato");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="modal-qr-code" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">QR Code della carta</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 pt-2">
          <img data-testid="qr-canvas" src={qrUrl} alt="QR" className="h-56 w-56 rounded-2xl border border-slate-200 bg-white p-3" />
          <div className="flex w-full items-center gap-2">
            <Input data-testid="input-copy-url" readOnly value={publicUrl} className="font-mono text-xs" />
            <Button data-testid="btn-copy-url" variant="outline" size="icon" onClick={copy}><Copy size={16} /></Button>
          </div>
          <div className="grid w-full grid-cols-2 gap-2">
            <Button data-testid="btn-download-qr-png" onClick={download} className="bg-indigo-600 hover:bg-indigo-700">
              <Download size={16} className="mr-2" /> Scarica PNG
            </Button>
            <a href={publicUrl} target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="w-full"><ExternalLink size={16} className="mr-2" /> Apri pagina</Button>
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
